import { observer } from "mobx-react";
import { toast } from "sonner";
import { useTranslation } from "@/i18n";
import { Panel } from "@/components/ui/panel";
import { SkillsPicker } from "@/components/profile/skills-picker";
import { useStore } from "@/stores/store-context";
import type { TSkill } from "@/types/skill";

interface MySkillsPickerProps {
  workspaceSlug: string;
  skills: TSkill[];
}

export const MySkillsPicker = observer(function MySkillsPicker({
  workspaceSlug,
  skills,
}: MySkillsPickerProps) {
  const { t } = useTranslation();
  const { userSkills } = useStore();

  if (skills.length === 0) {
    return (
      <Panel>
        <p className="text-sm text-muted-foreground">{t("profile.skills.empty")}</p>
      </Panel>
    );
  }

  const handleChange = async (nextIds: string[]) => {
    try {
      await userSkills.saveMySkills(workspaceSlug, nextIds);
      toast.success(t("profile.skills.save_success"));
    } catch {
      toast.error(t("profile.skills.save_error"));
    }
  };

  return (
    <Panel>
      <SkillsPicker
        skills={skills}
        selectedIds={userSkills.getAssignedSkillIds(workspaceSlug)}
        isSaving={userSkills.isSaving}
        onChange={handleChange}
      />
    </Panel>
  );
});
